import React, { FC } from 'react';

import { IUserStore } from '../../store/user/store';

interface IProps {
  backgroundImage?: string | null;
  children?: JSX.Element | JSX.Element[];
  taller?: boolean;
  handicap?: boolean;
  settings?: boolean;
  title?: string;
  user?: IUserStore;
  clubRoot?: boolean;
}

const PlayerSubHeader: FC<IProps> = props => {
  const { backgroundImage, children, clubRoot, taller, handicap, settings, title, user } = props;

  const style = backgroundImage
    ? {
        backgroundImage: !!settings
          ? // tslint:disable-next-line: max-line-length
            `linear-gradient(to bottom, rgba(250,250,250,0.65) 0%,rgba(250,250,250,0.64) 1%,rgba(250,250,250,0) 74%,rgba(250,250,250,0) 100%), url(${backgroundImage})`
          : clubRoot
          ? `url(${backgroundImage})`
          : `linear-gradient(180deg, rgba(250,250,250,0) 0%, var(--greyee) 100%), url(${backgroundImage})`,
        backgroundPosition: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }
    : {};

  return (
    <div className={`player-subheader-container ${taller ? 'taller' : ''}`}>
      <div className={handicap && user ? 'main-title' : 'main-title centered'} style={style}>
        <div className="mask" />
        {!!title && (
          <div className="title-container">
            <h2 className={backgroundImage ? '' : 'darker'}>{title}</h2>
          </div>
        )}
        <div className="children-container">{children}</div>
      </div>
    </div>
  );
};

export default PlayerSubHeader;
